import React, { lazy } from 'react';
import { FadeIn } from './FadeIn';
import { Star, Quote, Crown } from 'lucide-react';
interface Testimonial {
  quote: string;
  name: string;
  image: string;
  role?: string;
}
export function SistemaTestimonials() {
  const testimonials: Testimonial[] = [{
    quote: 'Por fin entendí cómo funciona Seller Central desde cero.',
    name: 'Laura Medina',
    image: 'https://randomuser.me/api/portraits/women/8.jpg',
    role: 'Emprendedora'
  }, {
    quote: 'Ahora sí entiendo la diferencia entre Amazon FBA y FBM.',
    name: 'Carlos Fernández',
    image: 'https://randomuser.me/api/portraits/men/11.jpg',
    role: 'Nuevo vendedor'
  }, {
    quote: 'Aprendí cómo encontrar productos ganadores paso a paso.',
    name: 'Daniela Ruiz',
    image: 'https://randomuser.me/api/portraits/women/17.jpg',
    role: 'Comenzando desde cero'
  }, {
    quote: 'El sistema explica campañas dentro Amazon de manera súper fácil.',
    name: 'Miguel Herrera',
    image: 'https://randomuser.me/api/portraits/men/18.jpg',
    role: 'Estudiante del sistema'
  }, {
    quote: 'No sabía cómo comenzar en Amazon y ahora entiendo todo mucho mejor.',
    name: 'Andrea López',
    image: 'https://randomuser.me/api/portraits/women/25.jpg',
    role: 'Emprendedora online'
  }, {
    quote: 'Me gustó porque es práctico y directo, sin información innecesaria.',
    name: 'José Ramírez',
    image: 'https://randomuser.me/api/portraits/men/36.jpg',
    role: 'Principiante'
  }, {
    quote: 'Llevaba meses viendo videos en YouTube y nunca entendía cómo comenzar. Aquí por fin encontré un sistema organizado y fácil de seguir. Ya logré publicar mis primeros productos.',
    name: 'Carlos M.',
    image: 'https://randomuser.me/api/portraits/men/32.jpg',
    role: 'Vendedor principiante'
  }, {
    quote: 'Me gustó que explican todo paso a paso y sin complicaciones. Sentí que realmente estaba aprendiendo desde cero y ahora entiendo mucho mejor cómo funciona Amazon.',
    name: 'Daniela R.',
    image: 'https://randomuser.me/api/portraits/women/44.jpg',
    role: 'Mamá emprendedora'
  }, {
    quote: 'Lo compré pensando que sería otro curso más, pero honestamente está muy bien explicado. Me ayudó bastante a entender FBA y FBM de manera práctica.',
    name: 'Miguel A.',
    image: 'https://randomuser.me/api/portraits/men/52.jpg',
    role: 'Aprendiendo desde casa'
  }, {
    quote: 'Lo que más me gustó fue que todo está organizado y fácil de aplicar. Ya estoy buscando productos y siento mucha más seguridad para comenzar.',
    name: 'Andrea C.',
    image: 'https://randomuser.me/api/portraits/women/68.jpg',
    role: 'Emprendedora online'
  }, {
    quote: 'Había comprado otros cursos antes y terminaba confundido. Este sistema se siente mucho más claro y profesional. Vale totalmente la pena.',
    name: 'Luis Fernando P.',
    image: 'https://randomuser.me/api/portraits/men/75.jpg',
    role: 'Comerciante independiente'
  }, {
    quote: 'Me encantó porque no necesitas experiencia previa para entenderlo. Todo está explicado de forma sencilla y práctica. Súper recomendado.',
    name: 'Valentina G.',
    image: 'https://randomuser.me/api/portraits/women/90.jpg',
    role: 'Estudiante del sistema'
  }];
  return <section className="bg-brand-white py-20 md:py-28 px-5 sm:px-6 relative overflow-hidden" data-id="element-695">
      {/* Subtle premium background accents */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-696">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-brand-gold/5 rounded-full blur-3xl" data-id="element-697"></div>
        <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-brand-green/5 rounded-full blur-3xl" data-id="element-698"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-699">
        {/* Header */}
        <FadeIn data-id="element-700">
          <div className="text-center mb-14 md:mb-20 max-w-3xl mx-auto" data-id="element-701">
            <div className="inline-flex items-center justify-center gap-2 bg-brand-green text-white border border-brand-gold/40 rounded-full px-5 py-2.5 mb-6 shadow-lg" data-id="element-702">
              <Crown className="w-4 h-4 text-brand-gold" data-id="element-703" />
              <span className="text-xs font-bold tracking-widest text-brand-gold uppercase" data-id="element-704">
                Sistema Profesional FBA + FBM
              </span>
            </div>

            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-brand-green mb-5 leading-[1.1] tracking-tight" data-id="element-705">
              Lo que dicen quienes ya están usando el sistema
            </h2>

            {/* Aggregate rating */}
            <div className="inline-flex items-center gap-3 mt-3 bg-brand-beige/60 border border-brand-gold/20 rounded-full px-5 py-2.5" data-id="element-706">
              <div className="flex gap-0.5" data-id="element-707">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-708" />)}
              </div>
              <span className="text-sm font-semibold text-brand-green" data-id="element-709">
                4.9 / 5 — basado en estudiantes reales
              </span>
            </div>
          </div>
        </FadeIn>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-id="element-710">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.05 * (index % 6)} data-id="element-711">
              <article className="group bg-white border border-brand-text/8 rounded-2xl p-7 md:p-8 h-full flex flex-col shadow-[0_2px_20px_-8px_rgba(0,0,0,0.08)] hover:shadow-[0_20px_40px_-15px_rgba(28,57,40,0.18)] hover:-translate-y-1 hover:border-brand-gold/30 transition-all duration-300" data-id="element-712">
                {/* Decorative quote icon */}
                <Quote className="w-8 h-8 text-brand-gold/30 mb-3" strokeWidth={2.5} data-id="element-713" />

                {/* Stars */}
                <div className="flex gap-0.5 mb-4" data-id="element-714">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-715" />)}
                </div>

                {/* Quote */}
                <p className="text-brand-text/85 leading-relaxed mb-6 flex-grow text-base md:text-lg font-medium" data-id="element-716">
                  "{testimonial.quote}"
                </p>

                {/* Divider */}
                <div className="h-px bg-brand-text/8 mb-5" data-id="element-717"></div>

                {/* Author */}
                <div className="flex items-center gap-3.5" data-id="element-718">
                  <div className="relative flex-shrink-0" data-id="element-719">
                    <img src={testimonial.image} alt={testimonial.name} loading="lazy" className="w-12 h-12 rounded-full object-cover ring-2 ring-white shadow-md" data-id="element-720" />
                    <span className="absolute -bottom-0.5 -right-0.5 w-4 h-4 bg-brand-green rounded-full border-2 border-white flex items-center justify-center" data-id="element-721">
                      <span className="text-white text-[8px] font-bold leading-none" data-id="element-722">
                        ✓
                      </span>
                    </span>
                  </div>
                  <div className="min-w-0" data-id="element-723">
                    <p className="font-semibold text-brand-green leading-tight truncate" data-id="element-724">
                      {testimonial.name}
                    </p>
                    {testimonial.role && <p className="text-xs text-brand-text/55 mt-0.5 truncate" data-id="element-725">
                        {testimonial.role}
                      </p>}
                  </div>
                </div>
              </article>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}